import { getRequestAPI, putRequestAPI } from "../utils/apiCalls";

const IP_URL = process.env.REACT_APP_NODE_API_URL

export async function getEquipments() {
  const response = await getRequestAPI('database-equipments');
  return response;
}

export async function getGpsGateTags() {
  const response = await getRequestAPI('gps-gate-tags');
  return response;
}

export async function getGpsGateUsers() {
  const response = await getRequestAPI('gps-gate-users');
  return response;
}

export async function getGpsGateMainUsers() {
  const response = await getRequestAPI('gps-gate-users/main');
  return response;
}

export async function getGpsGateBackupUsers() {
  const response = await getRequestAPI('gps-gate-users/backup');
  return response;
}

export async function getLastReview() {
  const response = await getRequestAPI('database-health-review');
  return response;
}

export async function putLastReview(body) {
  const response = await putRequestAPI('database-health-review', body);
  return response;
}


export const getEquipmentsByType = async (equipment_types, application_id) => {
  try {
    const response = await fetch(
      IP_URL  + "database_all_equipments_by_id",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          equipment_groups_list: equipment_types,
        }),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    //console.error("Error al iniciar sesión", error);
    var aux = 0;
  }
};